import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="footer pt-4 mt-auto">
      <div className="container">
        <div className="footer-sections">
          <div className="footer-column footer-brand">
            <div className="footer-heading">
              <h4>{t("footer.labArtseener")}</h4>
            </div>
            <ul className="footer-links">
              <li>
                <a
                  href="https://artseener.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("footer.artseener")}
                </a>
              </li>
            </ul>

            <div className="footer-heading">
              <h4>{t("footer.about")}</h4>
            </div>
            <p>{t("footer.aboutText")}</p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            © LabArtseener {new Date().getFullYear()} |{" "}
            <a
              href="https://artseener.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("footer.artseener")}
            </a>
          </p>
          <div className="social-icons my-auto">
            <a
              href="https://www.facebook.com/share/17PmafKbcD/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook"></i>
            </a>
            <a
              href="https://www.instagram.com/artseener"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://www.tiktok.com/@artseener35"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-tiktok"></i>
            </a>
            <a
              href="https://youtube.com/@artseener"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-youtube"></i>
            </a>
            <a
              href="https://www.linkedin.com/company/artseener"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-linkedin-in" title="LinkedIn"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
